import { useEffect, useState } from 'react';
import { TData } from 'entries/common/widgets/context';
import get from 'lodash/get';
import { hasProjectConfigurationData } from '../helpers/has-project-configuration-data';

export const useGetParametersCalculatorData = ({ data }: { data: TData }) => {
  const [calculatorParams, setCalcParams] = useState({});
  const [isError, setIsError] = useState(false);
  const [route, setRoute] = useState('surface');

  useEffect(() => {
    const api = data?.api;
    const hasProjectData = hasProjectConfigurationData(data);

    if (!__IS_SERVER__ && data?.productId && api) {
      if (hasProjectData) {
        setCalcParams(prev => ({ ...prev, ...data, isSurfaceOne: true }));
      } else {
        api
          .get(`/getParametersCalculator/${data?.productId}?regionId=${data?.regionId}`, {})
          .then(res => {
            setIsError(false);
            const surfaces = Object.keys(res.surface);
            const isSurfaceOne =
              surfaces.length === 1 &&
              Object.keys(get(res, 'surface[surfaces[0]].enums.baseSurface', {})).length <= 1;
            const currentRoute = isSurfaceOne ? 'dimensions' : 'surface';
            setCalcParams(prev => ({ ...prev, ...data, surfaces: res, isSurfaceOne }));
            setRoute(currentRoute);
          })
          .catch(() => {
            setCalcParams({});
            setIsError(true);
          });
      }
    }
  }, [data]);

  return {
    isError,
    calculatorParams,
    route,
    setRoute,
  };
};
